import { useDispatch } from 'react-redux'
import { useLoginMutation } from '../api/authAPI'
import { setUser } from '../store/slices/authSlice'
import LoginForm from '../components/LoginForm'
import { loginSchema } from '../features/auth/authSchema'
import { useState } from 'react'
import { z } from 'zod'
import { useNavigate } from 'react-router-dom';

type FormData = z.infer<typeof loginSchema>

const Login = () => {
  const dispatch = useDispatch()
  const [login, { isLoading }] = useLoginMutation()
  const [message, setMessage] = useState("")
  const [error, setError] = useState("")

  const navigate = useNavigate()

  const onSubmit = async (data: FormData) => {
    try {
      const res = await login(data).unwrap()
      dispatch(setUser(res.user))
      setMessage(res.message || "התחברת בהצלחה!!!")
      switch (res.user.role) {
        case 'admin':
          navigate('/admin-dashboard')
          break
        case 'mentor':
          navigate('/mentor-dashboard')
          break;
      }
      setError("")
      setTimeout(() => setMessage(""), 5000)
    } catch (err: any) {
      setMessage("")
      setError(err?.data?.message || "ההתחברות נכשלה,נסה שוב")
    }
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-100 via-muted to-blue-light p-4"
      dir="rtl"
    >
      <div
        className="w-full max-w-md px-8 py-6 bg-secondary rounded-xl border-2 shadow-card"
        style={{
          borderColor: 'rgb(14, 195, 1)',
          boxShadow: '0 8px 24px rgba(14, 195, 1, 0.25)',
        }}
      >

        <div className="flex justify-center mb-6">
          <img
            src='/logo.jpg'
            alt="Logo"
            className="w-32 h-auto object-contain"
          />
        </div>

        <LoginForm
          onSubmit={onSubmit}
          isLoading={isLoading}
          message={message}
          error={error}
        />
      </div>
    </div>
  )
}

export default Login
